(function () {
/**
 * Created by OlaD mango8x
 */ const $5a3fc3e2587399e4$var$_pg = {
    init: function() {
        // console.log("Khởi tạo trang...");
        // 
        var self = this;
        // 
        self.jq_Plugin_wow();
        self.jq_Plugin_fancyapp();
        self.jq_Plugin_modal();
        self.jq_Plugin_slider();
        self.jq_lazyload();
        self.jq_lazycss();
        self.header_scripts();
        self.normal_scripts();
    },
    jq_Plugin_wow: function() {
        if ($(window).width() > 768) {
            if ($(".wow").length) new WOW().init();
        }
    },
    jq_Plugin_fancyapp: function() {
        if ($("[data-fancybox]").length) Fancybox.bind("[data-fancybox]", {
            dragToClose: false,
            closeButton: "top",
            Toolbar: {
                display: [
                    {
                        id: "counter",
                        position: "center"
                    },
                    "close"
                ]
            }
        });
    },
    jq_Plugin_modal: function() {
        // set default value
        // $.modal.defaults.fadeDuration = 250;
        $.modal.defaults = {
            escapeClose: false,
            clickClose: false,
            showClose: false,
            fadeDuration: 250
        };
        // listening modal open and stop scroll
        if ($(".modal").length) $(".modal").on($.modal.OPEN, function(e, modal) {}).on($.modal.CLOSE, function(e, modal) {});
        // Call manual modal video
        // $('a[data-modal-video]').on('click ', function (event) {
        // 	$(this).modal({
        // 		showClose: false,
        // 		escapeClose: true,
        // 		clickClose: true,
        // 	});
        // 	return false;
        // });
        // 
        $('[rel="modal:close"]').on("click", function() {
        // location.reload();
        });
        // Test close Modal
        setTimeout(()=>{
        // $.modal.close();	
        // $('#ex1').modal();
        }, 100);
    },
    jq_Plugin_slider: function() {
        let _w = $(window).width();
        let _mb = $5a3fc3e2587399e4$var$getMobile();
        // Swiper slider
        // if (_w > 1366 || !_mb) return;
        // if (!_mb) return;
        // 
        // 
        if ($(".big-banner-slider").length) var bigBanner = new Swiper(".big-banner-slider", {
            grabCursor: true,
            spaceBetween: 50,
            speed: 600,
            // autoplay: {
            // 	delay: 5000,
            // 	disableOnInteraction: false
            // },
            loop: true,
            effect: "fade",
            // creativeEffect: {
            // 	prev: {
            // 		shadow: true,
            // 		translate: ["-20%", 0, -1],
            // 	},
            // 	next: {
            // 		translate: ["100%", 0, 0],
            // 	},
            // },
            pagination: {
                el: ".big-banner-slider .swiper-pagination",
                clickable: true
            },
            on: {
                init: function() {
                    updateCloneFromSlide(this.slides[this.activeIndex]);
                    $(".big-banner-slider .caption").addClass("active"); // Lúc khởi tạo, add luôn
                },
                slideChangeTransitionStart: function() {
                    $(".big-banner-slider .caption").removeClass("active");
                },
                slideChangeTransitionEnd: function() {
                    updateCloneFromSlide(this.slides[this.activeIndex]);
                    $(".big-banner-slider .caption").addClass("active");
                }
            }
        });
        // 
        if ($(".menu-list-slider").length) var menus = new Swiper(".menu-list-slider", {
            grabCursor: true,
            spaceBetween: 10,
            speed: 400,
            freeMode: true,
            // autoplay: {
            // 	delay: 2500,
            // 	disableOnInteraction: false
            // },
            // effect: "cards",
            // creativeEffect: {
            // 	prev: {
            // 		shadow: true,
            // 		translate: ["-20%", 0, -1],
            // 	},
            // 	next: {
            // 		translate: ["100%", 0, 0],
            // 	},
            // },
            pagination: {
                el: ".swiper-pagination",
                type: "progressbar"
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            }
        });
        // 
        if ($(".feedback-list").length) var feedbackList = new Swiper(".feedback-list", {
            // width: 'auto',
            slidesPerView: "auto",
            spaceBetween: 32,
            centeredSlides: false,
            breakpoints: {
                640: {
                    spaceBetween: 48
                },
                768: {
                    spaceBetween: 64
                },
                1024: {
                    spaceBetween: 64
                }
            }
        });
        // 
        function updateCloneFromSlide(slide) {
            var stlEl = $(slide).find(".sub-title").html();
            var tlEl = $(slide).find(".title").html();
            var dsEl = $(slide).find(".desc").html();
            // Update sub-title và desc như bình thường
            $(".caption .sub-title").html(stlEl);
            $(".caption .desc").html(dsEl);
            // Xử lý title tùy theo độ rộng màn hình
            var isMobile = window.innerWidth < 540;
            var result = "";
            if (isMobile) {
                // Gộp hết lại thành 1 dòng
                var textOnly = tlEl.replace(/<br\s*\/?>/gi, " ");
                result = '<p class="title">' + textOnly.trim() + "</p>";
            } else {
                // Chia dòng theo <br> như cũ
                var lines = tlEl.split(/<br\s*\/?>/i);
                lines.forEach(function(line) {
                    line = $.trim(line);
                    if (line) result += '<p class="title">' + line + "</p>";
                });
            }
            $(".caption .main-title").html(result);
        }
        // 
        var $promoSwipers = $('.swiper[class*="swiper-promo-"]');
        if ($promoSwipers.length) $promoSwipers.each(function(index) {
            var $this = $(this);
            var slideCount = $this.find(".swiper-slide").length;
            var shouldLoop = slideCount > 1;
            // Init Swiper
            var swiper_promo = new Swiper(this, {
                slidesPerView: 1,
                spaceBetween: 10,
                // loop: shouldLoop,
                speed: 300,
                // autoplay: shouldLoop ? {
                // 	delay: 4000,
                // 	disableOnInteraction: false
                // } : false,
                pagination: {
                    el: $this.find(".swiper-pagination")[0],
                    clickable: true
                }
            });
            console.log("Swiper promo #" + (index + 1) + " initialized");
        });
        else console.log("No swiper-promo found, skip init.");
    },
    jq_lazyload: function() {
        // --------------
        const fallbackSrc = myVars.noImage;
        const lazyImages = $(".lazy-img");
        if (lazyImages.length === 0) return;
        const observer = new IntersectionObserver((entries, observer)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    const img = $(entry.target);
                    const src = img.data("src");
                    // Ngăn sự kiện 'error' cũ dính lại
                    img.off("error");
                    // Gán class loading trước khi load
                    img.addClass("loading");
                    // Gán sự kiện 'load'
                    img.on("load", function() {
                        img.addClass("loaded").removeClass("loading");
                    });
                    // Gán sự kiện 'error'
                    img.on("error", function() {
                        const currentSrc = img.attr("src");
                        // Nếu đang không phải là fallback => fallback
                        if (currentSrc !== fallbackSrc) {
                            console.warn("Ảnh lỗi, fallback:", currentSrc);
                            img.attr("src", fallbackSrc);
                        } else {
                            console.warn("Fallback cũng lỗi. Bỏ qua.");
                            img.off("error"); // Ngắt vòng lặp
                        }
                        img.addClass("loaded");
                    });
                    // Đặt src để bắt đầu load ảnh thật
                    img.attr("src", src);
                    // Ngưng theo dõi
                    observer.unobserve(entry.target);
                }
            });
        }, {
            rootMargin: "100px"
        });
        lazyImages.each(function() {
            observer.observe(this);
        });
    },
    jq_lazycss: function() {
        $("<style>").prop("type", "text/css").html(`
                .lazy-img {
                    opacity: 0;
                    transition: opacity 0.5s ease-in-out;
                }
				.lazy-img.loading {
                    opacity: 0.7;
                }
                .lazy-img.loaded {
                    opacity: 1;
                }
            `).appendTo("body");
    },
    header_scripts: function() {
        // Header Menu mobile button hambuger open menu
        // open
        $("[data-hamburger]").on("click", function() {
            const self = $(this);
            self.toggleClass("opened");
            self.closest(".header-lv--1").toggleClass("change-index");
            self.closest("[data-header]").find("[data-menu]").stop().toggleClass("opened");
            self.closest("[data-header]").toggleClass("opened");
            $(".overlay").stop().fadeToggle();
            $("html, body").toggleClass("overflow-hidden");
        });
        $(".overlay").on("click", function() {
            $("[data-hamburger]").trigger("click");
        });
    },
    normal_scripts: function() {
        // 
        $(".toggle-password").click(function() {
            $(this).toggleClass("fa-eye fa-eye-slash un--password");
            var input = $($(this).attr("toggle"));
            if (input.attr("type") == "password") {
                input.attr("type", "text");
                input.attr("placeholder", "");
            } else {
                input.attr("type", "password");
                input.attr("placeholder", "**********");
            }
        });
        // Hover image rotate
        const imageElements = document.querySelectorAll(".hoverImage");
        imageElements.forEach((imageElement)=>{
            const handleMouseMove = (e)=>{
                let rect = imageElement.getBoundingClientRect();
                let x = e.clientX - rect.left;
                let y = e.clientY - rect.top;
                let dx = (x - rect.width / 2) / (rect.width / 2);
                let dy = (y - rect.height / 2) / (rect.height / 2);
                imageElement.style.transform = `perspective(500px) rotateY(${dx * 5}deg) rotateX(${-dy * 5}deg)`;
            };
            const handleMouseLeave = ()=>{
                imageElement.style.transform = "";
            };
            imageElement.addEventListener("mousemove", handleMouseMove);
            imageElement.addEventListener("mouseleave", handleMouseLeave);
        });
        // Video
        var $videoLink = $("#video-link");
        if ($videoLink.length === 0) return;
        var isMobile = $(window).width() <= 768;
        var videoSrc = isMobile ? $videoLink.data("portrait") : $videoLink.data("landscape");
        var width = isMobile ? $videoLink.data("width-portrait") : $videoLink.data("width-landscape");
        var height = isMobile ? $videoLink.data("height-portrait") : $videoLink.data("height-landscape");
        // Gán lại thuộc tính
        $videoLink.attr("href", videoSrc);
        $videoLink.attr("data-width", width);
        $videoLink.attr("data-height", height);
    }
};
// Toast function
function $5a3fc3e2587399e4$var$toast({ title: title = "", message: message = "", type: type = "info", duration: duration = 3000 }) {
    const main = document.getElementById("toast");
    if (main) {
        const toast = document.createElement("div");
        // Auto remove toast
        const autoRemoveId = setTimeout(function() {
            main.removeChild(toast);
        }, duration + 1000);
        // Remove toast when clicked
        toast.onclick = function(e) {
            if (e.target.closest(".toast__close")) {
                main.removeChild(toast);
                clearTimeout(autoRemoveId);
            }
        };
        const icons = {
            success: "fas fa-check-circle",
            info: "fas fa-info-circle",
            warning: "fas fa-exclamation-circle",
            error: "fas fa-exclamation-circle"
        };
        const icon = icons[type];
        const delay = (duration / 1000).toFixed(2);
        toast.classList.add("toast", `toast--${type}`);
        toast.style.animation = `slideInLeft ease .3s, fadeOut linear 1s ${delay}s forwards`;
        toast.innerHTML = `
					<div class="toast__icon">
						<i class="${icon}"></i>
					</div>
					<div class="toast__body">
						<h3 class="toast__title">${title}</h3>
						<p class="toast__msg">${message}</p>
					</div>
					<div class="toast__close">
						<i class="fas fa-times"></i>
					</div>
				`;
        main.appendChild(toast);
    }
}
// Check mobile
function $5a3fc3e2587399e4$var$getMobile() {
    return $("body").hasClass("mobile");
}
/**
 * document ready
 */ jQuery(function($1) {
    /**
	 * 
	 */ $5a3fc3e2587399e4$var$_pg.init();
});



})();
//# sourceMappingURL=scripts.js.map
